/// <reference path="../../../typings/tsd.d.ts" />
module warsApp.controllers {
    export interface BatchJobConfigurationScope extends angular.IScope {
        model: models.BatchJobConfigurationModel
    }

    export class BatchJobConfigurationController implements IController {
        constructor(
            private scope: BatchJobConfigurationScope,
            $routeParams: angular.route.IRouteParamsService,
            growlService: angular.growl.IGrowlService,
            batchJobConfigurationService: services.BatchJobConfigurationService,
            systemLevelService: services.SystemLevelService,
            deleteService: services.DeleteService,
            objectQueryService: services.ObjectQueryService,
            processActionService: services.ProcessActionService,
            treeService: services.TreeService,
            queryConfigurationService: services.QueryConfigurationService,
            timeZoneService: services.TimeZoneService) {
            var processConfigurationId = $routeParams["id"];

            this.scope.model = new models.BatchJobConfigurationModel(
                scope,
                growlService,
                batchJobConfigurationService,
                systemLevelService,
                deleteService,
                objectQueryService,
                processActionService,
                treeService,
                queryConfigurationService,
                timeZoneService,
                processConfigurationId);
        }
    }
}

warsApp.registerController('BatchJobConfigurationController',
    ['$scope', '$routeParams', 'growl', 'batchJobConfigurationService', 'systemLevelService', 'deleteService', 'objectQueryService', 'processActionService', 'treeService', 'queryConfigurationService', 'timeZoneService']
);